import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import authContext from '../context/authContext/authContext';
import AddProduct from '../components/modals/AddProduct';
import EditProduct from '../components/modals/EditProduct';
import Loader from '../utils/Loader';
import { deleteSelectedProductAction, editSelectedProductAction, getSelectedProductsAction } from '../redux/actions/selectedProductsAction';
import { showStatus } from '../utils/utils';
import UserDetailsModal from '../components/modals/UserDetailsModal';
import DematStatus from '../components/DematStatus';

const SelectedProducts = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const config = getConfig();
  const intialState = { products: [] }

  const [expandedRow, setExpandedRow] = useState(null);
  const [state, setCompleteState] = useState(intialState)
  const [expandedProducts, setExpandedProducts] = useState([]);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, selectedProducts } = useSelector((state) => state.selectedProducts)

  const deleteProduct = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteProduct(id);
      }
    });
  }

  const confirmDeleteProduct = async (id) => {
    const data = { id }
    dispatch(deleteSelectedProductAction(data, config, getSelectedProducts))
  }

  const getSelectedProducts = async () => {
    dispatch(getSelectedProductsAction(config))
  }

  const approveSelectedProduct = (id) => {
    const data = { status: "approved", _id: id, statusUpdate: true }
    dispatch(editSelectedProductAction(data, config, getSelectedProducts))
  }

  useEffect(() => {
    getSelectedProducts();
  }, []);

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Selected Products</h2>
            <div className='ml-3'>
              <Loader isLoading={loading} />
            </div>
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover text-center">
            <thead>
              <tr>
                <th scope="col">User ID</th>
                <th scope="col">Title</th>
                <th scope="col">Client ID</th>
                <th scope="col">Demat Status</th>
                <th scope="col">Tokens</th>
                <th scope="col">Time</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(selectedProducts || []).map((product) => {
                const {
                  _id,
                  userId,
                  title,
                  tokens,
                  status,
                  clientId,
                  dematStatus,
                  createdAt,
                } = product;

                const isApproved = status === 'approved';

                return (
                  <tr key={_id}>
                    <td>
                      <button className='btn p-0 m-0 btn-user-info' onClick={() => setState({ reqUserId: userId, showUserDetailsModal: true })}>{userId}</button>
                    </td>
                    <td><strong>{title}</strong></td>
                    <td>{clientId || '-'}</td>
                    <td><DematStatus dematStatus={dematStatus} /></td>
                    <td>{tokens || 0}</td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td>{showStatus(status)}</td>

                    <td className='actions-container'>
                      <button
                        className={`btn btn-sm my-1 mx-1 btn-${isApproved ? 'primary' : 'secondary'}`}
                        onClick={() => approveSelectedProduct(_id)}
                        disabled={status === 'approved'}
                        title={status === 'approved' ? "Approved" : "Approve"}
                      >
                        <i className='fa fa-check' />
                      </button>

                      <button
                        className='btn btn-danger btn-sm my-1 mx-1'
                        onClick={() => deleteProduct(_id)}
                        title="Delete"
                      >
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                );
              })}

            </tbody>
          </table>
        </div>
      </div>

      <AddProduct
        key={() => new Date()}
        isOpen={state?.openAddProductModal}
        parentId={state?.parentId}
        toggle={() => setState({ openAddProductModal: false, parentId: '' })}
        getProducts={getSelectedProducts}
        loading={loading}
      />

      <EditProduct
        key={() => new Date()}
        isOpen={state.openEditProductModal}
        toggle={() => setState({ openEditProductModal: false, parentId: null, subProductId: null })}
        parentId={state.parentId}
        subProductId={state.subProductId}
        products={selectedProducts || []}
        getProducts={getSelectedProducts}
        loading={loading}
      />

      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div >
  )
}

export default SelectedProducts;